<!--
 * @Author: Haotian Zheng
 * @Date: 2023-07-21 11:21:08
 * @Descripttion: 
 * @LastEditors: Haotian Zheng
 * @LastEditTime: 2023-07-28 21:35:35
-->
<!-- qff弹窗 -->
<template>
  <div v-if="showDialog" class="dialog-box">
    <div @click.stop="dialogBgClick" class="dialog-bg"></div>
    <div class="dialog-in-box" :height="height" :style="{ height: height }">
      <div class="header-row">
        <div class="header-title">
          <img v-if="type === 'warn'" class="header-title-img" src="@/assets/image/dialog/warn-icon.png" alt="" />
          <img v-if="type === 'delete'" class="header-title-img" src="@/assets/image/dialog/delete-icon.png" alt="" />
          <img v-if="type === 'success'" class="header-title-img" src="@/assets/image/dialog/success-icon.png" alt="" />
          <span>{{ title }}</span>
        </div>
        <div @click="closeDialog" class="header-close">
          <img src="@/assets/image/dialog/close.png" alt="" />
        </div>
      </div>
      <slot></slot>
      <div class="dialog-footer-btn-box">
        <div v-if="!noCloseBtn" :width="btnWidth" :style="{ width: btnWidth }" class="close-btn btn"
          @click.stop="closeDialog">{{ closeBtn }}
        </div>
        <div :width="btnWidth" :style="{ width: btnWidth }" v-if="sureBtn !== ''" class="sure-btn btn" @click="makeSure">
          {{ sureBtn }}</div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {}
  },

  // 是否显示弹窗
  props: {
    title: {
      type: String,
      default: '提示',
    },
    // 是否显示弹窗
    showDialog: {
      type: Boolean,
      default: false,
    },
    closeBtn: {
      type: String,
      default: '取消',
    },
    noCloseBtn: {
      type: Boolean,
      default: false,
    },
    sureBtn: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '240px',
    },
    type: {
      type: String,
      default: 'warn',
    },
    btnWidth: {
      type: String,
      default: null,
    },
    disableClickBg: {
      type: Boolean,
      default: false,
    },
    sureNotClose: {
      type: Boolean,
      default: false,
    },
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    dialogBgClick() {
      if (this.disableClickBg) {
        return
      }
      this.$emit('update:showDialog', false)
    },
    // 关闭弹窗
    closeDialog() {
      this.$emit('closeBtn')
      this.$emit('update:showDialog', false)
    },
    makeSure() {
      this.$emit('makeSure')
      if (this.sureNotClose) {
        return
      }
      this.$emit('update:showDialog', false)
    },
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.dialog-box {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  width: 100%;
  height: 100%;

  .header-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .dialog-in-box {
    margin: 0 auto;
    width: 600px;
    height: 240px;
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 30px 20px 30px 30px;
  }

  .dialog-bg {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0;
    left: 0;
  }

  .dialog-in-box {
    margin: 0 auto;
    width: 520px;
    height: 240px;
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 30px 20px 30px 30px;
  }

  .header-title {
    display: flex;
    justify-content: start;

    .header-title-img {
      width: 32px;
      height: 32px;
      margin-right: 9px;
    }

    span {
      height: 32px;
      font-size: 20px;
      font-family: Alibaba PuHuiTi 2-65 Medium, Alibaba PuHuiTi 20;
      font-weight: 600;
      color: #1a1a1a;
      line-height: 32px;
    }
  }

  .header-close {
    width: 20px;
    height: 21px;
    cursor: pointer;

    img {
      width: 20px;
      height: 21px;
    }
  }
}

.dialog-info {
  font-size: 14px;
  font-family: Alibaba PuHuiTi 2-55 Regular, Alibaba PuHuiTi 20;
  font-weight: 400;
  color: #767676;
  line-height: 24px;
  text-align: left;
}

.dialog-container {
  font-size: 14px;
  font-family: Alibaba PuHuiTi 2-55 Regular, Alibaba PuHuiTi 20;
  font-weight: 400;
  color: #767676;
  line-height: 24px;
  padding-left: 41px;
}

.dialog-footer-btn-box {
  height: 30px;
  position: absolute;
  bottom: 30px;
  left: 0;
  display: flex;
  justify-content: end;
  text-align: right;
  width: 100%;
  padding-right: 20px;

  //右对齐
  .btn {
    width: 64px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    font-size: 14px;
    border-radius: 2px;
    cursor: pointer;
    display: inline-block;
    margin-left: 14px;

    &.close-btn {
      background: #ffffff;
      border: 1px solid #aaaaaa;
      color: #424242;
      margin-left: 14px;
    }

    &.sure-btn {
      background: #be1a21;
      color: #ffffff;
    }
  }
}
</style>
